import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-container">
      <p>© Cheminformatics Lab (CCEN UFPB) | mtscotti@gmail.com</p>
    </footer>
  );
}

export default Footer;
